export const ADD_ERROR = "addError";
export const CLEAR_ERRORS = "clearErrors";
